import { render, staticRenderFns } from "./NavTop.vue?vue&type=template&id=39dbf046&scoped=true"
import script from "./NavTop.vue?vue&type=script&lang=js"
export * from "./NavTop.vue?vue&type=script&lang=js"
import style0 from "./NavTop.vue?vue&type=style&index=0&id=39dbf046&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbf046",
  null
  
)

export default component.exports